module.exports = __webpack_public_path__ + "img/16.b890ffa4.png";